export const debounceDelay = 1200;

export const statusFilterOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'active',
    label: 'Active',
  },

  {
    value: 'inactive',
    label: 'Inactive',
  },
];

export const statusFilter = {
  ACTIVE: 'active',
  ALL: 'all',
  INACTIVE: 'inactive',
};

export const sortbyFilter = {
  DESCEND: 'descend',
};

export const billingStrategy = {
  FLAT: 'flat',
  FLAT_EXTENDED: 'flat_extended',
  SOC_BASED: 'soc_based',
};

export const mqttType = {
  DATA_UPDATE: 'data_update',
  ACCEPT_SLOT_OPEN: 'accept_slot_open',
  USER_DATA: 'user_data',
  BATTERY_SUBMITTED: 'battery_submitted',
  PROVISION_SLOT_OPEN: 'provision_slot_open',
  BATTERY_REMOVED: 'battery_removed',
  BILLING: 'billing',
  BILLING_COMPLETE: 'billing_complete',
  TERMINATING: 'terminating',
  WARNING: 'warning',
};
